import { useContext, useEffect } from "react";
import { AppContext } from "../../../AppProvider";
import { DashboardContext } from "./DashboardProvider";
import "../../../../styles/workspace_styles/TenantAdministratorStyles/Dashboards/DeleteDashboard.css";
import { thingsBoardMicroserviceUrl } from "../../../../microservices/thingsboard_microservice";

const DeleteDashboard = ({showDeleteDashboardWindow,setShowDeleteDashboardWindow}) =>{
    const {user} = useContext(AppContext);
    const {
        setDashboardSummaries,
        selectedTenantAdminProfile,
        dashboardSummary,setDashboardSummary} = useContext(DashboardContext);
    const deleteDashboard = async() =>{
        try{
            const url = `${thingsBoardMicroserviceUrl}/tenants/profiles/${selectedTenantAdminProfile?.id}/dashboards/${dashboardSummary?.id}`;
            const response = await fetch(url,{
                method:'DELETE',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user.access_token}`
                },
            });
            if(response.ok){
                setDashboardSummaries(prev => prev.filter(existingDashboardSummary => existingDashboardSummary?.id !== dashboardSummary?.id));
                setDashboardSummary(null);
                setShowDeleteDashboardWindow(false);
            }
            else throw new Error(`Status code: ${response.status}`);
        }
        catch(error){
            console.error(`An error occurred when deleting dashboard with title: ${dashboardSummary?.title} and id: ${dashboardSummary?.id} => `,error);
        }
    };
    if(!showDeleteDashboardWindow || !dashboardSummary) return null;
    return(
        <div className="delete-dashboard-parent-container">
            <div className="delete-dashboard-container">
                <h1>Are you sure you want to delete the dashboard '{dashboardSummary?.title}'?</h1>
                <p>Be careful, after the confirmation, the dashboard and all related data will become unrecoverable.</p>
                <div className="buttons-container">
                    <button className="cancel-button" onClick={() =>{
                        setDashboardSummary(null);
                        setShowDeleteDashboardWindow(false);
                    }}>
                        No
                    </button>
                    <button className="delete-button" onClick={async() =>await deleteDashboard()}>
                        Yes
                    </button>
                </div>
            </div>
        </div>
    );
};
export default DeleteDashboard;